<template>
  <span v-if="identifier == 'document_reference' && value">
    <a :href="documentLink(value)" class="i-documents-file-pdf" />
  </span>
  <span v-else :title="value">{{ value }}</span>
</template>

<script>
import { escape } from 'lodash'

export default {
  name: 'OpenTransactionCell',
  props: ['identifier', 'value'],
  methods: {
    documentLink(text) {
      return Silverfin.Routes.document_path(
        Silverfin.currentFirmId,
        Silverfin.currentCompanyId,
        escape(text)
      )
    },
  },
}
</script>
